// src/utils/anonId.js
// Persistent anonymous ID for guest voting before account creation

const ANON_ID_KEY = 'gweffit_anon_id';

/**
 * Generate a UUID v4
 */
function generateUUID() {
  // Use crypto.randomUUID if available (modern browsers)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Get or create a persistent anonymous ID for this device.
 * Used to track guest votes before the user creates an account.
 * @returns {string} UUID
 */
export function getAnonId() {
  try {
    let anonId = localStorage.getItem(ANON_ID_KEY);
    if (!anonId) {
      anonId = generateUUID();
      localStorage.setItem(ANON_ID_KEY, anonId);
      console.log('🆔 Created new anon_id:', anonId);
    }
    return anonId;
  } catch (e) {
    // If localStorage fails, generate a session-only ID
    console.warn('⚠️ localStorage unavailable, using session anon_id');
    return generateUUID();
  }
}

/**
 * Check if there's an existing anon_id (user has done guest activity)
 * @returns {string|null}
 */
export function getExistingAnonId() {
  try {
    return localStorage.getItem(ANON_ID_KEY);
  } catch {
    return null;
  }
}

/**
 * Clear the anon_id after successful claim (optional - can keep for debugging)
 */
export function clearAnonId() {
  try {
    localStorage.removeItem(ANON_ID_KEY);
    console.log('🆔 Cleared anon_id');
  } catch {
    // Ignore
  }
}

/**
 * Check if user has any pending guest votes that need claiming
 * @returns {boolean}
 */
export function hasPendingGuestActivity() {
  return !!getExistingAnonId();
}
